import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { Children, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { fields } from "../constants";
import { FieldValues } from "react-hook-form";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "~/Utils/CommonUtils";
import { corporateHost } from "~/Utils";
import { AirlineServicesAndIncentives } from "./AirlineServicesAndIncentives/AirlineServicesAndIncentives";
import { useAboutUs } from "~/Modules/ECMS/ERAMAN/Forms/Pages/Pages.hook";
import { AirlineIncentives } from "./AirlineIncentives/AirlineIncentives";

export const AirlineServices = () => {
  const query = useQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if(query.get('id')){
      return;
    }
    const subActiveTab = query.get("subActiveTab");
    const thirdSubActiveTab = query.get("thirdChildActiveTab")
    if (query.get("activeTab") === "airlineServices") {
      let defaultThirdChildActiveTab = "";
    
      switch (subActiveTab) {
        case "airlineIncentives":
          defaultThirdChildActiveTab = "airlineIncentivesPageHeading";
          break;
        case "airlineServicesFacilities":
          defaultThirdChildActiveTab = "airlineServicesFacilitiesPageHeading";
          break;
      }
    
      navigate(
        `/dedicated/corporate/business-oppurtunities?activeTab=airlineServices&subActiveTab=${
          subActiveTab || "airlineServicesFacilities"
        }&thirdChildActiveTab=${thirdSubActiveTab || defaultThirdChildActiveTab}`,
        {
          replace: true,
        }
      );
    }    
  }, [query.get("activeTab"), query.get('subActiveTab')]);

  const aboutEramanChildItems = [
    {
      label: "Airline Services Facilities",
      key: 'airlineServicesFacilities',
      children: <AirlineServicesAndIncentives/>
    },
    {
      label: "Airline Incentives",
      key: 'airlineIncentives',
      children: <AirlineIncentives/>
    },
  ];

  return (
      <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={aboutEramanChildItems}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
  );
};
